import {
  type CarbonIconType,
  ColumnInsert,
  DocumentAdd,
  Flow,
  Image,
  Link,
  ListBulleted,
  ListNumbered,
  Quotes,
  Redo,
  RowInsert,
  TableSplit,
  TextBold,
  TextColor,
  TextItalic,
  TextScale,
  Undo,
  Video,
} from '@carbon/icons-react'

export const LABEL_MAP = {
  bold: [TextBold, 'Fett'],
  italic: [TextItalic, 'Kursiv'],
  'block-quote': [Quotes, 'Blockzitat'],
  'heading-one': [TextScale, 'Titel'],
  'heading-two': [TextScale, 'Überschrift 1'],
  'heading-three': [TextScale, 'Überschrift 2'],
  'numbered-list': [ListNumbered, 'Sortierte Liste'],
  'bulleted-list': [ListBulleted, 'Aufzählungsliste'],
  paragraph: [TextScale, 'Normaler Text'],
  file: [DocumentAdd, 'Datei einfügen'],
  'file-block': [DocumentAdd, 'Datei einfügen'],
  image: [Image, 'Bild einfügen'],
  video: [Video, 'Video einfügen'],
  link: [Link, 'Link einfügen'],
  undo: [Undo, 'Rückgängig'],
  redo: [Redo, 'Wiederholen'],
  table: [TableSplit, 'Tabelle'],
  'table-row': [RowInsert, 'Tabellenzeile'],
  'table-cell': [ColumnInsert, 'Tabellenspalte'],
  flow: [Flow, 'FlowChart'],
  color: [TextColor, 'Textfarbe'],
} as const satisfies {
  [format: string]: [Icon: CarbonIconType, title: string]
}
